console.log('variant-selects.js loaded ✅');

if (!window.customElements.get('variant-selects')) {
  console.log("Defining variant-selects component");

  window.customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      console.log("✅ variant-selects initialized");
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    /*
if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
      console.log('VariantSelects script initialized');
    }
    */

    onVariantChange() {
      console.log('onVariantChange triggered');
      this.updateOptions();
      this.updateMasterId();
      this.updateURL();
      this.updateMedia();
      this.updatePrice();
      this.updateAddToCart();
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), select => select.value);
    }

    /*
    updateMasterId() {
      this.variant = this.getVariantData().find((variant) => {
        return variant.options.every((option, index) => {
          return this.options[index] === option;
        });
      });
    
      if (this.variant) {
        const input = document.querySelector('input[name="id"]');
        if (input) {
          input.value = this.variant.id; // ✅ Use direct assignment instead of setAttribute
          console.log('Updated variant ID to:', this.variant.id); // ✅ Optional for debugging
        }
      }
    }
    */

    updateMasterId() {
        this.variant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => this.options[index] !== option).includes(true);
        });
      
        if (this.variant) {
          const input = document.querySelector('input[name="id"]'); // Changed from this.querySelector(...)
          if (input) {
            input.setAttribute('value', this.variant.id);
          }
        }
      }

    updateURL() {
      if (!this.variant || this.dataset.updateUrl === 'false') return;
      history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    updateMedia() {
      if (!this.variant || !this.variant.featured_media) return;
      const mediaId = this.variant.featured_media.id;
      const mediaElement = document.querySelector(`[data-media-id="${mediaId}"]`);
      if (mediaElement) mediaElement.click();
    }

    updatePrice() {
      if (!this.variant) return;
      const priceWrapper = document.getElementById(`price-${this.dataset.section}`);
      if (priceWrapper) {
        const priceEl = priceWrapper.querySelector('.product-price');
        if (priceEl) priceEl.textContent = Shopify.formatMoney(this.variant.price);
      }
    }

    updateAddToCart() {
      const button = this.querySelector('[name="add"]');
      if (!this.variant || !this.variant.available) {
        if (button) {
          button.setAttribute('disabled', true);
          button.textContent = 'Sold out';
        }
      } else {
        if (button) {
          button.removeAttribute('disabled');
          button.textContent = 'Add to cart';
        }
      }
    }

    getVariantData() {
      if (!this.variantData) {
        const dataElement = this.querySelector('[type="application/json"]');
        this.variantData = dataElement ? JSON.parse(dataElement.textContent) : [];
      }
      return this.variantData;
    }
  });
}
